var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { class: _vm.tableClass },
    [
      _c(
        "div",
        { staticClass: "row row-border" },
        _vm._l(_vm.columns, function (colHeader, colKey, colIndex) {
          return _c(
            "div",
            {
              key: colKey,
              class:
                _vm.buildCellClass(colIndex) + " col-header center-vertically",
            },
            [_vm._v("\n            " + _vm._s(colHeader) + "\n        ")]
          )
        }),
        0
      ),
      _vm._v(" "),
      _vm._l(_vm.rows, function (row, index) {
        return _c(
          "div",
          { key: index, staticClass: "row row-border" },
          _vm._l(row, function (cellText, cellKey, cellIndex) {
            return _c(
              "div",
              {
                key: cellKey,
                class: _vm.buildCellClass(cellIndex) + " center-vertically",
              },
              [_vm._v("\n            " + _vm._s(cellText) + "\n        ")]
            )
          }),
          0
        )
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }